module.exports = __webpack_public_path__ + "static/img/banner11.2ebc24e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner11.jpg
// module id = 46Iw
// module chunks = 73